import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BatchInfo, Content } from '@xanadu/model';
import { HttpClient } from '@angular/common/http';
import { UrlHelper } from '../url-helper';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

    constructor(
        private readonly http: HttpClient,
        private readonly urlHelper: UrlHelper
    ) {
    }

    public pick(id: string): Observable<Content[]> {
        return this.http.get<any[]>(`${this.urlHelper.for(Content)}/pick/${id}`).pipe(
            map(data => data?.map(item => {
                const content = new Content();
                content.load(item);
                return content;
            }))
        );
    }

    public batch(request: BatchInfo): Observable<any[]> {
        let url = this.urlHelper.for(Content);
        url = `${url}/batch`;
        const model = request.model;
        return this.http.post<any[]>(url, model);
    }
}
